import { render, staticRenderFns } from "./LoanList.vue?vue&type=template&id=bd871e6a"
import script from "./LoanList.vue?vue&type=script&lang=js"
export * from "./LoanList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports